












import Vue from 'vue';
import ValidationHelper from '@/helpers/ValidationHelper';
import ArrowIcon from '../../icons/ArrowIcon.vue';

export default Vue.extend({
  name: `MobileMenuHeadline`,
  components: { ArrowIcon },
  props: {
    arrowDown: {
      default: false,
      type: Boolean,
    },
    color: {
      default: `#ffffff`,
      type: String,
      validator: prop => ValidationHelper.checkIfStringIsHexColor(prop) || prop === `#ffffff`,
    },
    content: {
      default: ``,
      type: String,
    },
  },
});
